export default "__VITE_ASSET__DNquNdHS__"